<app-grid>
  <app-info-area>
    <h3 class="pb-4 text-primary text-xl font-bold dark:text-white">Resources</h3>
    <p>Here you can view a list of all currently available resources, click a folder icon in the tree to expand it.</p>
    <!-- First card -->
    <div class="navigator-card downloads-main">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="scroll-shadow scrollable">
        <!-- File Node -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding (click)="handleNodeClick(node)" [ngClass]="{ selected: isNodeSelected(node) }">
          <button mat-icon-button disabled></button>
          <mat-icon class="material-symbols-outlined">note</mat-icon>  <!-- File Icon -->
          {{node.name}}
        </mat-tree-node>
        <!-- Directory Node -->
        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding (click)="handleNodeClick(node)" (dblclick)="toggleNode(node)" [ngClass]="{ selected: isNodeSelected(node) }">
          <button mat-icon-button [attr.aria-label]="'toggle ' + node.name" matTreeNodeToggle>
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <mat-icon class="material-symbols-outlined">{{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}</mat-icon>  <!-- Dynamically change icon -->
          {{node.name}}
        </mat-tree-node>
      </mat-tree>
    </div>
  </app-info-area>
  <app-content-area>
    <mat-card class="download-card">
      <h3 class="pb-4 text-primary text-xl font-bold dark:text-white">{{ selectedNode?.name || 'Nothing Selected'}}</h3>
      @if(selectedNode?.type === 'file' && selectedNode?.filesize != null){
        <div>
          {{selectedNode?.filesize | fileSize}}
        </div>
      }
      <div [innerHTML]="selectedNode?.description" class="description scroll-shadow scrollable"></div>

      @if (selectedNode?.name && selectedNode?.type === 'file') {
        <div>
          <div class="actions">
            <a [href]="'assets/download' + selectedNode?.path" download="{{selectedNode?.name}}" class="btn btn-primary">
              Download
            </a>
          </div>
        </div>
      }
    </mat-card>
  </app-content-area>
</app-grid>
